import { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { ImportModal } from './ImportModal';
import { useAuthStore } from '@/store/authStore';
import './TopBar.css';

function initials(login: string): string {
  const parts = login.replace(/@.*/, '').split(/[.\-_ ]+/).filter(Boolean);
  const letters = parts.length >= 2 ? parts[0][0] + parts[1][0] : login.slice(0, 2);
  return letters.toUpperCase();
}

export function TopBar() {
  const [showImport, setShowImport] = useState(false);
  const navigate = useNavigate();
  const user = useAuthStore((s) => s.user);
  const logout = useAuthStore((s) => s.logout);

  function onLogout() {
    logout();
    navigate('/login', { replace: true });
  }

  return (
    <>
      <header className="topbar">
        <div className="logo">
          SQL-M8<span className="logo-sub">/console</span>
        </div>
        <nav className="topbar-nav">
          <NavLink to="/editor"   className={({ isActive }) => isActive ? 'active' : ''}>Editor</NavLink>
          <NavLink to="/audit"    className={({ isActive }) => isActive ? 'active' : ''}>Auditoria</NavLink>
          <NavLink to="/approvals" className={({ isActive }) => isActive ? 'active' : ''}>
            Aprovações <span className="badge-warn">3</span>
          </NavLink>
        </nav>
        <div className="topbar-right">
          <button className="topbar-import-btn" onClick={() => setShowImport(true)}>↑ Importar</button>
          <div className="env-badge">PRODUÇÃO</div>
          <div className="user-chip" title={user?.roles?.join(', ')}>
            <div className="avatar">{initials(user?.login ?? 'dev')}</div>
            <span>{user?.login ?? 'dev.user'}</span>
          </div>
          <button className="logout-btn" onClick={onLogout} title="Sair">Sair</button>
        </div>
      </header>
      {showImport && <ImportModal onClose={() => setShowImport(false)} />}
    </>
  );
}
